import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WafDialog = _resolveComponent("WafDialog")!

  return (_openBlock(), _createBlock(_component_WafDialog, { "waf-support": _ctx.WAF_SUPPORT }, null, 8, ["waf-support"]))
}